import React from 'react';
import Page from 'pages/Page';
import ListingTotal from 'components/ListingTotal';
import { getPriceStr, pluralize } from 'utils';
import isUndefined from 'lodash/isUndefined';
import BookingForm from 'components/BookingForm';
import BookingFormWrap from 'components/BookingFormWrap';
import FormResult from 'components/FormResult';

export default class Booking extends React.Component {

  componentWillMount() {
    this.props.updateActiveListing(this.props.listing._id);
  }

  componentWillUnmount() {
    this.props.resetBooking();
  }

  onSubmit(data) {
    data = {
      ...data,
      listingId: this.props.listing._id,
      startDate: this.props.startDate,
      endDate: this.props.endDate,
      guestsCount: this.props.guests
    };

    this.props.onSubmit(data);
  }

  onSubmit = this.onSubmit.bind(this);

  renderListingInfo() {
    const { listing, startDate, endDate, guests, isTotalCollapsed } = this.props;
    const {
      picture,
      title,
      reservation: { cleaningFee, basePrice, currency, nightsCount, totalPrice, fareAccommodation, pricePerNight },
      address: { full: address },
      propertyType,
      terms: { cancellation }
    } = listing;
    const src = picture.regular;
    const checkIn = startDate.format("MMM. D, YYYY");
    const checkOut = endDate.format("MMM. D, YYYY");

    const fareAccommodationOrBasePrice = fareAccommodation || basePrice;
    const basePriceStr = getPriceStr(fareAccommodationOrBasePrice, currency);
    const pricePerNightOrBasePrice = pricePerNight || basePrice;
    const pricePerNightStr = getPriceStr(pricePerNightOrBasePrice, currency);
    const cleaningFeeStr = getPriceStr(cleaningFee, currency);
    const totalPriceStr = getPriceStr(totalPrice, currency);
    const guestsStr = `${guests} ${pluralize('guest', guests)}`;

    return (
      <div className="col-md-5">
        <div className="listing-img" style={{backgroundImage: `url(${src})`}}/>
        <div className="px-5 py-45">
          <div className="text-title mb-2 line-height-12">{title}</div>
          <p className="mb-45">{address}</p>
          <div className="hidden-sm-down">
            <h5 className="mb-45">{propertyType}</h5>
            <h5>{nightsCount} {pluralize('night', nightsCount)}</h5>
            Check in: {checkIn}<br/>
            Check out: {checkOut}
            <h5 className="my-3">{guestsStr}</h5>
            {/* adults and kids are not implemented in this sprint */}
          </div>
          <div className="hidden-md-up font-size-md font-weight-normal">
            <div className="row no-gutters">
              <div className="col">
                {checkIn} - {checkOut}
              </div>
              <div className="col-auto">
                {guestsStr}
              </div>
            </div>
          </div>
          <div className="separator mt-45"/>
          <ListingTotal pricePerNight={pricePerNightStr} basePrice={basePriceStr} totalPrice={totalPriceStr} cleaningFee={cleaningFeeStr} nights={nightsCount} light={true} collapsed={isTotalCollapsed}/>
          <div className="row mt-55 text-xl-left text-center flex-column flex-xl-row">
            <div className="col-xl">Full payment will be charged on booking</div>
            <div className="col-xl-auto text-xl-right">Cancellation Policy: <b>{cancellation}</b></div>
          </div>
        </div>
      </div>
    );
  }

  renderConfirm(bookData) {
    let title, text;
    if (bookData.err) {
      title = 'Ooooops';
      text = <span>Something went wrong.<br/>Please try again or email us at <b>{this.props.email}</b></span>;
    } else if (this.props.isCreditCard) {
      title = 'Your reservation is confirmed';
      text = <span>Reservation number <b>{bookData.confirmationCode}</b>.<br/>We will email your confirmation shortly.</span>;
    } else {
      title = 'Your request has been successfully sent';
      text = '';
    }
    return (
      <FormResult title={title} text={text} isSuccess={!bookData.err} />
    );
  }

  render() {
    const { pageTitle, booked } = this.props;

    let content;
    if (!isUndefined(booked)) {
      content = this.renderConfirm(booked);
    } else {
      content = <BookingForm {...this.props} onSubmit={this.onSubmit}/>;
    }

    content = <BookingFormWrap>{content}</BookingFormWrap>;

    const listingInfo = this.renderListingInfo();

    return (
    <Page title={pageTitle}>
      <div className="row no-gutters flex-column-reverse flex-md-row">
        <div className="col-md-7 d-flex flex-column justify-content-xl-center align-items-center p-5 bg-inverse">
          {content}
        </div>
        {listingInfo}
      </div>
    </Page>
    );
  }
}


// WEBPACK FOOTER //
// ./src/pages/Booking.js